module.exports = __webpack_public_path__ + "img/netflix.png";